export default function mapShouldUpdate(messages = {}) {
  const {
    defaultMessages = [],
    headlineMessages = [],
    hiddenMessages = [],
    standardMessages = [],
  } = messages;
  return [
    ...headlineMessages,
    ...hiddenMessages,
    ...standardMessages,
  ].some(({ category }) => category === 'Route' || defaultMessages.some(({ type }) => type === 'MapShouldUpdateMessage'));
}